import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { initialize } from 'redux-form';

const API = `${consts.API_URL}/cliente`;

export const CLIENTE_MODO_TELA = 'CLIENTE_MODO_TELA';
export const CLIENTE_SET_AGUARDANDO = 'CLIENTE_SET_AGUARDANDO';
export const CLIENTE_LISTADO = 'CLIENTE_LISTADO';

const normalizarRegistro = registro => ({
    ...registro,
    ids_consultores: Array.isArray(registro.ids_consultores)
        ? registro.ids_consultores
        : (registro.ids_consultores || '')
            .toString()
            .split(',')
            .map(item => parseInt(item.trim(), 10))
            .filter(item => item),
    contatos: registro.contatos || []
});

const prepararFormulario = registro => ({
    ...registro,
    tipo_pessoa: registro.tipo_pessoa || (registro.cpf ? 'fisica' : 'juridica'),
    contatos: registro.contatos && registro.contatos.length
        ? registro.contatos
        : [
            {
                id: null,
                nome: '',
                celular: '',
                email: ''
            }
        ]
});

export function setModoTela(modo, registro = {}) {
    return {
        type: CLIENTE_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: CLIENTE_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('clienteForm', prepararFormulario(registro))
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: CLIENTE_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado = normalizarRegistro(registro);

            if (registroNormalizado.id) {
                await axios.put(API, registroNormalizado);

                setSuccess('Operação realizada com sucesso.');

                dispatch(getLista());
                dispatch(setModoTela('lista'));

                return;
            }

            const resp = await axios.post(API, registroNormalizado);
            const registroIncluido = {
                ...registroNormalizado,
                ...resp.data
            };

            setSuccess('Cliente incluído com sucesso. Agora você pode adicionar as áreas.');

            dispatch(setModoTela('cadastro', registroIncluido));
            dispatch(initForm(registroIncluido));
            dispatch(getLista());

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
